// extracted by css-extract-rspack-plugin
export default {"FilterTabItem":"FilterTabItem-module__FilterTabItem___UR11M"};